module.exports = __webpack_public_path__ + "img/graph-insitu-min.ab4399ab.png";